import React from "react";
import { Outlet } from "react-router-dom";
import SidebarEglise from "../components/eglise/SidebarEglise";

export default function EgliseLayout() {
  return (
    <div className="d-flex flex-column flex-lg-row" style={{ minHeight: "100vh" }}>
      <SidebarEglise />
      <main className="flex-grow-1 p-3" style={{ marginTop: "0" }}>
        <div className="d-lg-none" style={{ height: "60px" }}></div>
        <Outlet />
      </main>
    </div>
  );
} 